// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerFile_root__3gjgR"};